import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { Capacitor } from '@capacitor/core'
import { App as CapApp } from '@capacitor/app'
import App from './App'
import './index.css'
import { checkAndClearOldCache } from './lib/storage'
import { initPostHog } from './lib/posthog'

// Detect Capacitor native shell (WKWebView doesn't match display-mode: standalone)
if (window.Capacitor?.isNativePlatform?.()) {
  document.documentElement.classList.add('capacitor');
}

// Check for old cache and clear if version changed
// This runs BEFORE React renders
const isReloading = checkAndClearOldCache()

/**
 * On cold start via Universal Link, the WebView URL is always https://localhost/
 * so BrowserRouter would initialize at "/". We check getLaunchUrl() BEFORE React
 * renders and set the correct path via history.replaceState so BrowserRouter
 * picks up the deep link path (e.g. "/scan") immediately.
 */
async function getDeepLinkPath() {
  if (!Capacitor.isNativePlatform()) return null;
  try {
    const result = await CapApp.getLaunchUrl();
    if (result?.url) {
      const parsed = new URL(result.url);
      if (parsed.hostname === 'gettilted.app' || parsed.hostname === 'www.gettilted.app') {
        const path = parsed.pathname;
        if (path && path !== '/' && !path.includes('login-callback')) {
          return path + parsed.search + parsed.hash;
        }
      }
    }
  } catch (e) {
    console.error('[DeepLink] getLaunchUrl failed:', e);
  }
  return null;
}

async function init() {
  if (isReloading) return;

  initPostHog();

  const deepLinkPath = await getDeepLinkPath();
  if (deepLinkPath) {
    console.log('[DeepLink] cold-start path:', deepLinkPath);
    window.history.replaceState(null, '', deepLinkPath);
  }

  ReactDOM.createRoot(document.getElementById('root')).render(
    <React.StrictMode>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </React.StrictMode>,
  )
}

init();
